import { Box, Link, Typography, type SxProps, type Theme } from '@mui/material';

export const PACKBYTES_URL = 'https://packbytes.com/';

/**
 * "Powered by PackBytes" credit with the copyright line. The year comes from the clock, so it
 * moves to the next year on its own.
 */
export function PoweredBy({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <Box sx={sx}>
      <Typography
        variant="caption"
        color="text.secondary"
        component="p"
        align="center"
        sx={{ m: 0 }}
      >
        Powered by{' '}
        <Link
          href={PACKBYTES_URL}
          target="_blank"
          rel="noopener"
          underline="hover"
          sx={{ fontWeight: 700, color: 'text.primary' }}
        >
          PackBytes
        </Link>
      </Typography>
      <Typography
        variant="caption"
        color="text.secondary"
        component="p"
        align="center"
        sx={{ m: 0, fontSize: '0.6875rem' }}
      >
        © {new Date().getFullYear()} PackBytes. All rights reserved.
      </Typography>
    </Box>
  );
}

/** The same credit as plain text for printed documents and receipts. */
export function poweredByText(): string {
  return `Powered by PackBytes · packbytes.com · © ${String(new Date().getFullYear())} PackBytes. All rights reserved.`;
}
